/**
 * =============================================================
 * AADHAV ACADEMY – ADMIN FEE REPORTS THUNK
 * Role: Admin
 * Scope: Async actions for fetching financial reports & defaulters
 * Standard: Enterprise / MNC Level
 * =============================================================
 */

import { createAsyncThunk } from "@reduxjs/toolkit";
import { getFeeReportsSummary } from "../../api/admin/fee_reports.api";

/* ================= FETCH FEE REPORTS SUMMARY ================= */

export const fetchFeeReportsSummary = createAsyncThunk(
  "admin/feeReports/fetchSummary",
  async (params = {}, { rejectWithValue }) => {
    try {
      const res = await getFeeReportsSummary(params);

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        filter_context: res.filter_context,
        financial_summary: res.financial_summary,
        defaulters_count: res.defaulters_count,
        defaulters_list: res.defaulters_list,
      };
    } catch (error) {
      return rejectWithValue(error.message || "Failed to fetch fee reports summary.");
    }
  }
);